import axios from "axios";
import { getAccessToken } from "./authSession";
import { API_BASE_URL } from "../config";

const getAuthHeaders = () => {
    const token = getAccessToken();
    if (!token) {
        window.location.href = "/";
        return {};
    }
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

// Скачивает Excel-отчёт по текущему snapshot business_store_offers.
// Бэкенд генерирует файл на диске, поэтому держим запас по timeout, но без
// принудительного refresh supplier feeds в рамках этого запроса.
export const downloadBusinessStockReport = async () => {
    const response = await axios.get(`${API_BASE_URL}/business-stock-report/export`, {
        ...getAuthHeaders(),
        responseType: "blob",
        timeout: 10 * 60 * 1000,
    });

    const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "business_stock_report.xlsx";
    link.click();
    URL.revokeObjectURL(url);
};
